/** admin/games — HOOKS. */
import { useMutation, useQuery, useQueryClient, type QueryClient } from '@tanstack/react-query';
import { gamesApi } from './api';
import { adminGamesKeys } from './keys';
import type { CreateGamePayload, UpdateGamePayload } from './types';

const invalidate = (qc: QueryClient) => qc.invalidateQueries({ queryKey: adminGamesKeys.all() });

export function useAdminGames(page = 1, limit = 20) {
  return useQuery({ queryKey: adminGamesKeys.list({ page, limit }), queryFn: () => gamesApi.list(page, limit) });
}

export function useAdminGamesAll(enabled = true) {
  return useQuery({
    queryKey: adminGamesKeys.flat(),
    // Fetch a large page; the admin UI uses this as a flat list for selectors.
    queryFn: async () => (await gamesApi.list(1, 200)).data,
    enabled,
  });
}

export function useCreateGame() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (payload: CreateGamePayload) => gamesApi.create(payload), onSuccess: () => invalidate(qc) });
}

export function useUpdateGame() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (v: { id: string; payload: UpdateGamePayload }) => gamesApi.update(v.id, v.payload), onSuccess: () => invalidate(qc) });
}

export function useDeleteGame() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (id: string) => gamesApi.remove(id), onSuccess: () => invalidate(qc) });
}
